<script setup>
// O TECLADO DA URA desenhado (reformulação da Central, 26/09/2026 — referência:
// o editor de IVR do 3CX v20 e do Yeastar, que mostram o teclado do aparelho).
// As teclas com destino acendem em íris; as sem uso ficam apagadas. Passar o
// mouse numa tecla mostra para onde ela manda. É o mesmo retrato que o cliente
// tem na mão quando ouve "tecle 1 para…".
import { computed } from 'vue';

const props = defineProps({
  opcoes: { type: Object, default: () => ({}) },
  rotulo: { type: Function, default: d => d },
});

const TECLAS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
const teclas = computed(() =>
  TECLAS.map(k => ({
    k,
    destino: props.opcoes[k] || '',
  }))
);
</script>

<template>
  <div class="teclado" aria-hidden="true">
    <span
      v-for="(x, i) in teclas"
      :key="x.k"
      v-tooltip="x.destino ? rotulo(x.destino) : ''"
      class="teclado__tecla"
      :class="{ 'teclado__tecla--usa': x.destino }"
      :style="{ '--i': i }"
    >
      {{ x.k }}
    </span>
  </div>
</template>

<style scoped>
.teclado {
  display: grid;
  grid-template-columns: repeat(3, 28px);
  gap: var(--esp-1);
  padding: var(--esp-2);
  border-radius: var(--r-4);
  background: rgb(var(--slate-2));
  box-shadow: inset 0 0 0 1px rgb(var(--slate-4));
}
.teclado__tecla {
  display: grid;
  place-content: center;
  height: 28px;
  border-radius: var(--r-redondo);
  font-size: var(--txt-nota);
  font-weight: var(--peso-forte);
  font-variant-numeric: tabular-nums;
  color: rgb(var(--slate-8));
  background: rgb(var(--solid-1));
  box-shadow: inset 0 0 0 1px rgb(var(--slate-4));
}
.teclado__tecla--usa {
  color: #fff;
  background: linear-gradient(160deg, rgb(var(--iris-9)), rgb(var(--iris-10)));
  box-shadow: 0 4px 10px -4px rgb(var(--iris-9) / 80%);
  animation: teclado-acende var(--mov-4) var(--mov-curva) both;
  animation-delay: calc(var(--i) * var(--cascata-passo));
}
@keyframes teclado-acende {
  from {
    transform: scale(0.6);
    opacity: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .teclado__tecla--usa {
    animation: none;
  }
}
</style>
